import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export const PaymentCancel = () => (
  <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="payment-cancel-page">
    <XCircle className="h-10 w-10 text-sovereign" />
    <h1 className="font-heading text-2xl font-bold text-white">Checkout cancelled</h1>
    <p className="text-sm text-slate-500">No charge was made. You can retry anytime.</p>
    <Link to="/" className="text-sovereign underline" data-testid="payment-cancel-home-link">Back to BrandSignal</Link>
  </div>
);
